/**
 * @module
 * @name Sidenav
 * @description Renders all nav items with router-links and different content
 *              related to, such as icons.
 */
export default {
  name: 'Sidenav',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
